export class MajorelPayload {
  public Iban: string;
  public BLZ: string;
  public Filialnummer: string;
  public Depotnummer: string;
  public Kundennummer: string;
  public Gemeinschaftskonto: boolean;
  public Kontoinhaber1: MajorelBankAccountOwner;
}

class MajorelBankAccountOwner {
  public Adresse: MajorelAddress;
  public Vorname: string;
  public Nachname: string;
  public Geburtsdatum: string;
  public SteuerId: string;
  public Steuerpflichtig: boolean;
}

class MajorelAddress {
  public Plz: string;
  public Ort: string;
  public Strasse: string;
  public Hausnummer: string;
}

export class MajorelPostData {
  public customerData: MajorelPostDataPair;
  public signature: MajorelPostDataPair;

  constructor(customerData: string, signature: string) {
    this.customerData = new MajorelPostDataPair('Kundendaten', customerData);
    this.signature = new MajorelPostDataPair('Signatur', signature);
  }
}

class MajorelPostDataPair {
  public name: string;
  public value: string;

  constructor(name: string, value: string) {
    this.name = name;
    this.value = value;
  }
}
